import { config } from "../config";
import postApi from "../services/apiService";
import axios from "axios";

async function createUser(userform) {
  const payload = {
    fn: "common_fn",
    se: "cr_us",
    data: { ...userform },
  };

  const resp = await postApi(payload);
  return resp;
}

async function updateUser(userform) {
  const payload = {
    fn: "common_fn",
    se: "up_us",
    data: { ...userform },
  };

  const resp = await postApi(payload);
  return resp;
}

async function fetchUsers(
  user_name = null,
  user_row_id = null,
  page = 1,
  limit = 20
) {
  const payload = {
    fn: "common_fn",
    se: "fe_us",
    data: {
      user_name,
      user_row_id,
      page,
      limit,
    },
  };
  const resp = await postApi(payload);
  return resp;
}

async function fetchUserSummary(
  user_name = null,
  user_row_id = null,
  page = 1,
  limit = 20
) {
  const payload = {
    fn: "common_fn",
    se: "fe_us_sum",
    data: {
      user_name,
      user_row_id,
      page,
      limit,
    },
  };

  const resp = await postApi(payload);
  return resp;
}

async function fetchHistoryOfUser(
  // user_name = null,
  user_row_id = null,
  bookId = null,
  page = 1,
  limit = 20
) {
  const payload = {
    fn: "common_fn",
    se: "fe_us_his",
    data: {
      // user_name,
      user_row_id,
      bookId,
      page,
      limit,
    },
  };

  const resp = await postApi(payload);
  return resp;
}

async function checkDeleteUser(user_row_id) {
  const payload = {
    fn: "common_fn",
    se: "chk_del_us",
    data: {
      user_row_id,
    },
  };

  const resp = await postApi(payload);
  return resp;
}

async function deleteUser(user_row_id) {
  const payload = {
    fn: "common_fn",
    se: "del_us",
    data: {
      user_row_id,
    },
  };

  const resp = await postApi(payload);
  return resp;
}

async function fetchIssuedBooks(user_row_id) {
  const payload = {
    fn: "common_fn",
    se: "fe_is",
    data: {
      user_row_id,
    },
  };

  const resp = await postApi(payload);
  return resp;
}

async function userIssuedBooks(user_row_id, search = null, currentPage) {
  const payload = {
    fn: "common_fn",
    se: "us_is_bo",
    data: {
      user_row_id,
      search,
      currentPage
    },
  };

  const resp = await postApi(payload);
  return resp;
}

async function fetchDepts() {
  const payload = {
    fn: "common_fn",
    se: "fe_dpt",
    data: "",
  };

  const resp = await postApi(payload);
  return resp;
}

async function fetchSubDeptsByDeptId(dept_id) {
  const payload = {
    fn: "common_fn",
    se: "fe_sub_dpt_id",
    data: {
      dept_id,
    },
  };

  const resp = await postApi(payload);
  return resp;
}

async function fetchRacks() {
  const payload = {
    fn: "common_fn",
    se: "fe_ra",
    data: "",
  };

  const resp = await postApi(payload);
  return resp;
}

async function fetchBookDetails(book_row_id) {
  const payload = {
    fn: "common_fn",
    se: "fe_bo_de",
    data: {
      book_row_id,
    },
  };

  const resp = await postApi(payload);
  return resp;
}

async function submitBook(book) {
  const payload = {
    fn: "common_fn",
    se: "cr_bo",
    data: { ...book },
  };

  const resp = await postApi(payload);
  return resp;
}

async function uploadFile(formData) {
  const resp = await axios.post(`${config.apiBaseURL}/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data", folder: "img" },
  });
  return resp;
}

export const api = {
  createUser,
  updateUser,
  fetchUsers,
  fetchHistoryOfUser,
  fetchUserSummary,
  // fetchReturn,
  checkDeleteUser,
  deleteUser,
  fetchIssuedBooks,
  userIssuedBooks,
  fetchDepts,
  fetchSubDeptsByDeptId,
  fetchRacks,
  fetchBookDetails,
  submitBook,
  uploadFile,
};
